import { Button, Flex, Form } from 'antd'
import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormItem } from '../../../../components/form-item'
import { useMessageTemplates } from '../../../message-template-hooks'
import { StoreInput } from '../../../input/store-input'
import { useCreateCampaignStepsContext, WHATSAPP_SETUP } from '../campaign-create-steps-context'
import { Paragraph } from '../paragraph'
import { Title } from '../title'
import { useWhatsappBusinessAccounts } from '../../../../whatsapp-business-account-hooks'
import { TemplateSelect } from './template-select'
import { WhatsappBusinessAccountSelect } from './whatsapp-business-account-select'
import { usePhoneNumbers } from '../../../../whatsapp-business-account/phone-number-hooks'
import { PhoneNumberSelect } from './phone-number-select'
import { useTemplateLanguageNotice } from '../../../template-language-notice'

export function WhatsappSetupStep() {
    const { t } = useTranslation()
    const { currentStep, previousStep, nextStep, selectedType, formProps } = useCreateCampaignStepsContext()
    const accountsQuery = useWhatsappBusinessAccounts()
    const selectedWhatsappBusinessAccountId = Form.useWatch('whatsappBusinessAccountId', formProps.form)
    const phoneNumberId = Form.useWatch('phoneNumberId', formProps.form)
    const startId = Form.useWatch('startMessageTemplateId', formProps.form)
    const phoneNumbersQuery = usePhoneNumbers(selectedWhatsappBusinessAccountId)

    const accounts = accountsQuery.data || []

    const startTemplatesQuery = useMessageTemplates({
        enabled: !!selectedWhatsappBusinessAccountId,
        preservePreviousData: false,
        query: {
            size: 100,
            sort: '-created_at',
            filters: {
                purpose: ['start'],
                whatsappBusinessAccountId: selectedWhatsappBusinessAccountId
                    ? [selectedWhatsappBusinessAccountId]
                    : undefined,
            },
        },
    })

    const startTemplates = startTemplatesQuery.data?.data || []
    const templateLanguageNotice = useTemplateLanguageNotice(startTemplates.find((template) => template.id === startId))
    const allSelected = phoneNumberId && startId

    if (!selectedType) {
        return null
    }

    return (
        <div className={clsx({ hidden: currentStep !== WHATSAPP_SETUP })}>
            <Title>{t('WhatsApp')}</Title>
            <Paragraph type="secondary">
                {t('Choose the WhatsApp account, phone number, and templates this campaign should use.')}
            </Paragraph>

            <FormItem<StoreInput>
                label={t('WhatsApp business account')}
                name="whatsappBusinessAccountId"
            >
                <WhatsappBusinessAccountSelect
                    allowClear
                    accounts={accounts}
                    loading={accountsQuery.isLoading}
                    onChange={() => {
                        formProps.form.setFieldValue('phoneNumberId', undefined)
                        formProps.form.setFieldValue('startMessageTemplateId', undefined)
                        formProps.form.setFieldValue('recontactSchedule', [])
                    }}
                />
            </FormItem>

            <FormItem<StoreInput>
                label={t('Phone number')}
                name="phoneNumberId"
            >
                <PhoneNumberSelect
                    phoneNumbers={phoneNumbersQuery.data?.data || []}
                    loading={phoneNumbersQuery.isLoading}
                    disabled={!selectedWhatsappBusinessAccountId}
                />
            </FormItem>

            <FormItem<StoreInput>
                label={t('Start message')}
                name="startMessageTemplateId"
                extra={templateLanguageNotice}
            >
                <TemplateSelect
                    templates={startTemplates}
                    loading={startTemplatesQuery.isLoading}
                    disabled={!selectedWhatsappBusinessAccountId}
                />
            </FormItem>

            <Flex justify="space-between">
                <Button
                    size="large"
                    onClick={previousStep}
                >
                    {t('Back')}
                </Button>
                <Button
                    size="large"
                    type="primary"
                    onClick={nextStep}
                    disabled={!allSelected}
                >
                    {t('Continue')}
                </Button>
            </Flex>
        </div>
    )
}
